import { makeStyles } from '@material-ui/core';

import Tooltip from '~/components/Tooltip';
import { CloseSmallIcon } from '~/icons';

const useStyles = makeStyles(theme => ({
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.text7,
    '&:hover': {
      color: theme.palette.primary.text1,
      cursor: 'pointer',
    },
    marginLeft: '-24px',
    zIndex: 999,
  },
}));

export default function CloseSuggestion({ onClose }) {
  const classes = useStyles();
  return (
    <div className={classes.buttonWrapper} onClick={onClose}>
      <Tooltip title="Clear" placement="bottom">
        <CloseSmallIcon size={16} strokeWidth={3} />
      </Tooltip>
    </div>
  );
}
